import { Component,
         AfterViewInit }        from '@angular/core';
import { MatDialogRef }          from '@angular/material';
import { TrainCycleService }       from './../shared/train-cycle.service';
import { Globals }              from './../common/globals';
import { Observable }           from 'rxjs/Observable';
import { TrainCycleDialogModel, TnTrainCyclesNextTrainException }     from './train-cycle-dialog.model';
import {TrainCycleSortableFilter} from './../train-cycle-list/train-cycle-sortable-filter';
import { TrainCycleExceptionService } from '../shared/train-cycle-exception.service';

@Component({
  selector: 'sa-train-cycle-dialog',
  template: require('./train-cycle-dialog.component.html'),
  styles: [require('./train-cycle-dialog.component.scss')]
})
export class TrainCycleDialogComponent implements AfterViewInit {

  public newItem = false;
  public model: TrainCycleDialogModel;
  private trainCycles: Observable<any>;
  private dataReady = false;
  public requestDeleteCheck = false;

  public errors = [];

  constructor(
    public dialogRef: MatDialogRef<TrainCycleDialogComponent>,
    private trainCyclesService: TrainCycleService,
    private trainCycleExceptionsService: TrainCycleExceptionService,
    public globals: Globals
  ) {

  }

  ngAfterViewInit() {
    Observable.forkJoin(
      this.trainCyclesService.getItems(new TrainCycleSortableFilter('name')),
      this.trainCycleExceptionsService.detail(this.model.cycleUID))
      .subscribe((res: Array<any>) => {
        this.trainCycles = res[0];
        this.model.cycleExceptions = res[1];
        if (!(res[0] as Array<any>).filter(c => c.cycleUID === this.model.nextCycleUID).length) {
          this.model.nextCycleUID = '';
        }
        this.dataReady = true;
      });
  }

  delete() {
      this.trainCyclesService.isCycleAssigned(this.model.cycleUID).subscribe((trains: Array<any>) => {
        if (trains.length > 0) {
          let trainNames = Array.prototype.join.call(trains.map(t => t.descr), '\n');
          alert('Tento cyklus je přiřazen ke spojům: \n' + trainNames + '\n\nNejdříve je nutné odstranit těmto spojům přiřazené cykly.');
        } else {
          if (confirm('Opravdu si přejete odstranit tento záznam?')) {
            this.dialogRef.close('delete');
            return;
          }
        }
        this.dialogRef.close();
      });
  }

  setProducts() {
    this.dialogRef.close('set-products');
  }

  setTrainOrder() {
    this.dialogRef.close('set-train-order');
  }

  save() {
    this.errors = [];
    if (this.errors.length === 0) {
      this.model.tnTrainCycleExceptions = [];
      for (const ce of this.model.cycleExceptions) {
        let tc = new TnTrainCyclesNextTrainException();
        //if (!!ce.cycleUID) {
          tc.cycleUID = this.model.cycleUID;
          tc.dayOfW = ce.dayOfW;
          tc.nextCycle = ce.nextCycle;
          tc.trainCyclesNextTrainExceptionsUID = !ce.trainCyclesNextTrainExceptionsUID ?
                                                      '00000000-0000-0000-0000-000000000000' : ce.trainCyclesNextTrainExceptionsUID;
          this.model.tnTrainCycleExceptions.push(tc)
      //}
      }
      this.dialogRef.close('save');
    }
  }

  public dayOfWeek(dayOfW: number): string {
    switch (dayOfW) {
      case 1:
        return 'Ne';
      case 2:
        return 'Po';
      case 3:
        return 'Út';
      case 4:
        return 'St';
      case 5:
        return 'Čt';
      case 6:
        return 'Pá';
      case 7:
        return 'So';
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-dialog/train-cycle-dialog.component.ts